'use strict';
import angular from 'angular';

import modalCreativeLibraryHtmlUrl from '../views/modal_creativeLibrary.html';
import modalCreativeToLineItemHtmlUrl from '../views/modal_creativeToLineItem.html';
import modalPixelToLineItemHtmlUrl from '../views/modal_pixelToLineItem.html';
import modalAddCreativeHtmlUrl from '../views/modal_addCreative.html';
import modalHtmlUrl from '../views/modal.html';
import modalFindIdsHtmlUrl from '../views/modal_findIds.html';
import modalCopyLineItemHtmlUrl from '../views/modal_copyLineItem.html';
import modalAddRuleHtmlUrl from '../views/modal_addRule.html';
import modalServiceMapperHtmlUrl from '../views/modal_serviceMapper.html';
import modalTemplateHtmlUrl from '../views/formTemplates/modal_template.html';
import modalWfTemplateHtmlUrl from '../views/wfTemplates/modal_wfTemplate.html';
import modalIntegrationsTemplateHtmlUrl from '../views/integrationsTemplates/modal_integrations_template.html';
import modalAddWatcherHtmlUrl from '../views/modal_addWatcher.html';
import modalSelectDefaultTemplateHtmlUrl from '../views/modal_packageSelectDefault.html';
import modalCreativeFacebookHtmlUrl from '../views/modal_creativeLibraryFacebook.html';
import modalUnprocessableEntityUrl from '../views/modal_unprocessableEntity.html'
import modalBiddingHelperTextUrl from '../views/modal_biddingHelperText.html'
import _ from "lodash";

angular.module('modals.services', [])

    .factory('ModalService', ModalService);

//
// Modal factory
//
ModalService.$inject = ['$modal'];

function ModalService($modal) {
    var service = {};
    //used for setting private form functions
    var self = this;

    /*
        By : VRathore
        Note: This will be the new way of defining a modal service. This provides an alternative definition of the service which is easier for development and allows for the separation of HTML and JS.
    */



    self.creativeLibrary = function(data) {

        return $modal.open({
            controller: 'AddCreativeLibraryModalController',
            templateUrl: modalCreativeLibraryHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    self.creativeLibraryFb = function(self) {

        return $modal.open({
            controller: 'AddCreativesFacebookModalController',
            templateUrl: modalCreativeFacebookHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return self;
                }
            }
        });

    };

    self.creativeToLineItem = function(data) {

        return $modal.open({
            controller: 'CreativeToLineItemModalController',
            templateUrl: modalCreativeToLineItemHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    self.pixelToLineItem = function(data) {

        return $modal.open({
            controller: 'PixelToLineItemModalController',
            templateUrl: modalPixelToLineItemHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    self.addCreative = function(data) {

        return $modal.open({
            controller: 'AddCreativeModalController',
            templateUrl: modalAddCreativeHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    self.findIds = function(data) {

        return $modal.open({
            controller: 'FindIdsModalController',
            templateUrl: modalFindIdsHtmlUrl,
            backdrop: 'static',
            size: 'lg',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    //NEW DEFINITIONS END HERE

    //private functions
    self.reassignTask = function(data) {
        return {
            controller: 'ReassignTaskModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.assignQueue = function(data) {
        return {
            controller: 'AssignQueueModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.reassign = function(data) {
        return {
            controller: 'ReassignModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.submitUser = function(data) {
        return {
            controller: 'SubmitUserModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.assignCampaignManager = function(data) {
        return {
            controller: 'AssignCampaignManagerModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.bulkStatusChangeLineItems = function(data) {
        return {
            controller: 'LineItemStatusChangeController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.taskTimelog = function(data) {
        return {
            controller: 'TaskTimelogModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.cancelReason = function(data) {
        return {
            controller: 'CancelReasonModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createCancelReason = function(data) {
        return {
            controller: 'CreateCancelReasonModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.exceptionLogs = function(data) {
        return {
            openedClass: 'logs-modal-open',
            controller: 'ExceptionLogsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };

    };

    self.commonLog = function(data) {
        return {
            openedClass: 'logs-modal-open',
            controller: 'CommonLogModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };

    };

    // TODO: Moved to new page, Remove after testing TO-688
    self.salesforceConnectionForm = function(data) {
        return {
            controller: 'SalesforceConnectionFormModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.integrationForm = function(data) {
        return {
            controller: 'IntegrationFormModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                },
                isSalesForceModel: function() {
                    return data.isSalesForceModel;
                }
            }
        };
    };

    /*self.fileIntegrationForm = function(data) {
        return {
            controller: 'FileIntegrationModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };*/

    self.addMapping = function(data) {
        return {
            controller: 'AddMappingModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data;
                }
            }
        };
    };

    self.deleteMapping = function(data) {
        return {
            controller: 'DeleteMappingModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data;
                }
            }
        };
    };

    self.deleteIntegration = function(data) {
        return {
            controller: 'DeleteIntegrationModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.inventoryEvents = function(data) {
        return {
            openedClass: 'inventory-modal-open',
            controller: 'InventoryEventsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.inventoryAvailableEvents = function(data) {
        return {
            openedClass: 'inventory-modal-available',
            controller: 'InventoryAvailableEventsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.inventoryReservedEvents = function(data) {
        return {
            openedClass: 'inventory-modal-available',
            controller: 'InventoryReservedEventsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.nightlyStatus = function(data) {
        return {
            openedClass: 'logs-modal-open',
            controller: 'NightlyStatusModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.notifications = function(data) {
        return {
            controller: 'NotificationsModalController',
            templateUrl: modalHtmlUrl,
            size: 'sm',
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.showHelpertexts = function() {
        return {
            controller: 'HelperTextController',
                templateUrl: modalBiddingHelperTextUrl,
                size: 'sm',
                backdrop: 'static'
        }
    };

    self.getBulkKeywords = function(data) {
        return {
            controller: 'GetBulkKeywordsController',
            templateUrl: modalHtmlUrl,
            size: 'md',
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.reporting = function(data) {
        return {
            controller: 'ReportingModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.updateHideConditionForm = function(data) {
        return {
            controller: 'UpdateHideConditionModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.addFormLookupContent = function(data) {
        return {
            openedClass: 'lookup-modal-container',
            controller: 'AddFormLookupContentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.cloneFormLookupContent = function(data) {
        return {
            controller: 'CloneFormLookupContentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.deleteLookupContent = function(data) {
        return {
            controller: 'DeleteLookupContentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.createLookupContent = function(data) {
        return {
            controller: 'CreateLookupContentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.createLookupType = function(data) {
        return {
            controller: 'CreateLookupTypeModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };

    self.deleteCreative = function(data) {
        return {
            controller: 'DeleteCreativeModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.deletePixel = function(data) {
        return {
            controller: 'DeletePixelModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.lineItemChanges = function(data) {
        return {
            controller: 'LineItemChangesModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.flightChanges = function(data) {
        return {
            controller: 'FlightChangesModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.moveFlight = function(data) {
        return {
            controller: 'MoveFlightModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.autoCreateFlights = function(data) {
        // Make the modal large if we have more than 1 distributed-target fields to display, else leave it medium as usual.
        let sizeString = 'md';
        const distributedTargetFields = _.filter(data.data.flightFields, function(field) {return field.input_type == 'distributed-target' && field.active == 1;});
        if (distributedTargetFields.length > 2) {
            sizeString = 'lg';
        }
        return {
            controller: 'AutoCreateFlightsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: sizeString,
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.showFormulaErrors = function(data) {
        return {
            controller: 'ShowFormulaErrorsModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.redistributeValues = function(data) {
        let sizeString = 'md';
        const distributedTargetFields = _.filter(data.data.flightFields, function(field) {return field.input_type == 'distributed-target' && field.active == 1;});
        if (distributedTargetFields.length > 2) {
            sizeString = 'lg';
        }
        return {
            controller: 'RedistributeValuesModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: sizeString,
            resolve: {
                data: function () {
                    return data.data;
                }
            }
        }
    };

    self.copyLineItem = function(data) {
        return {
            controller: 'CopyLineItemModalController',
            controllerAs: 'vm',
            templateUrl: modalCopyLineItemHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data
                }
            }
        }
    };

    self.addRoutingRuleSet = function(data) {
        return {
            controller: 'AddRoutingRuleSetModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.addRuleSet = function(data) {
        return {
            controller: 'AddRuleSetModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };


    self.addRule = function(data) {
        return {
            controller: 'AddRuleModalController',
            templateUrl: modalAddRuleHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createWorkflow = function(data) {
        return {
            controller: 'CreateWorkflowModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.showRuleSet = function(data) {
        return {
            controller: 'ShowRuleSetModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createRoutingRule = function(data) {
        return {
            controller: 'CreateRoutingRuleModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createRoutingCondition = function(data) {
        return {
            controller: 'CreateRoutingConditionModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createWorkflowTask = function(data) {
        return {
            controller: 'CreateWorkflowTaskModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createWorkflowTaskInterlocking = function(data) {
        return {
            controller: 'CreateWorkflowTaskInterlockingModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.addWorkflowTask = function(data) {
        return {
            controller: 'AddWorkflowTaskModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createWorkflowAction = function(data) {
        return {
            controller: 'CreateWorkflowActionModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createCustomStatus = function(data) {
        return {
            controller: 'CreateCustomStatusModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createProduct = function(data) {
        return {
            controller: 'CreateProductModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createProductGroup = function(data) {
        return {
            controller: 'CreateProductGroupModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.cloneProductGroup = function(data) {
        return {
            controller: 'CloneProductModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.cloneFormGroup = function(data) {
        return {
            controller: 'CloneFormModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.updateProductsHideConditionForm = function(data) {
        return {
            controller: 'UpdateProductsHideConditionModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        }
    };
    self.addProductContent = function(data) {
        return {
            openedClass: 'lookup-modal-container',
            controller: 'AddProductContentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.lookupContentClone = function(data) {
        return {
            controller: 'LookupContentCloneModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.lookupContentForClusterClone = function(data) {
        return {
            controller: 'LookupContentForClusterCloneModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.comment = function(data) {
        return {
            controller: 'CommentModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.orderWatchersListModel = function(data) {
        return {
            controller: 'OrderWatchersListModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.serviceMapper = function(data) {

        return $modal.open({
            controller: 'ServiceMapperModalController',
            templateUrl: modalServiceMapperHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data;
                }
            }
        });

    };

    self.createFormTemplate = function(data) {
        return {
            controller: 'CreateFormTemplateModalController',
            templateUrl: modalTemplateHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.createWfTemplate = function(data) {
        return {
            controller: 'CreateWfTemplateModalController',
            templateUrl: modalWfTemplateHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.cloneIntegrationTemplate = function(data) {
        return {
            controller: 'CloneIntegrationTemplateModalController',
            templateUrl: modalIntegrationsTemplateHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.addWatchersList = function(data) {
        return {
            controller: 'AddWatcherModalController',
            templateUrl: modalAddWatcherHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };
    
    self.createNewForm = function(data) {
        return {
            controller: 'CreateNewFromModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.forceAddOrUpdateForm = function(data) {
        return {
            controller: 'ForceAddOrUpdateFormModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.forceAddOrUpdateFormField = function(data) {
        return {
            controller: 'ForceAddOrUpdateFormFieldModalController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    self.packageSetDefault = function(data) {
        return {
            controller: 'PackageSetDefaultController',
            templateUrl: modalSelectDefaultTemplateHtmlUrl,
            backdrop: 'static',
            size: data.input_type == 'dfp_ad_units' ? 'lg':'',
            resolve: {
                data: function() {
                    return data;
                }
            }
        };
    };

    self.assignPlacements = function(data) {
        return {
            controller: 'AssignPlacementsController',
            templateUrl: modalHtmlUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: function() {
                    return data.data;
                }
            }
        };
    };

    //public service method used for returning the correct modal form
    service.returnModalType = function(type, data) {
        if (self.hasOwnProperty(type)) {
            return self[type](data);
        } else {
            return { error: 'This connection modal type does not exist.' };
        }
    };

    service.openUnprocessableEntityModal = function(data) {
        return $modal.open({
            controller: 'UnprocessableEntityModalController',
            controllerAs: 'vm',
            templateUrl: modalUnprocessableEntityUrl,
            backdrop: 'static',
            size: 'md',
            resolve: {
                data() {
                    return data
                }
            }
        })
    }

    return service;
}
